import { getMessages } from '../../../../../../store/constants';

export const DEMO_BUTTON_TITLE = getMessages().getText('dialog.blocker-snooze.demo.button.title');
export const DEMO_BUTTON_TEXT = getMessages().getText('dialog.blocker-snooze.demo.button.text');
export const DEMO_BUTTON_BUTTON = getMessages().getText('dialog.blocker-snooze.demo.button-sign');
export const DEMO_BUTTON_PURCHASE = getMessages().getText('dialog.blocker-snooze.demo.button-purchase');
